var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.83 10.884 1.473-1.473.59-.59a3.333 3.333 0 0 0 0-4.714v0a3.333 3.333 0 0 0-4.714 0l-.59.59L9.116 6.17m1.768 7.66-1.473 1.473-.59.59a3.333 3.333 0 0 1-4.713 0v0a3.333 3.333 0 0 1 0-4.715l.589-.589L6.17 9.116",
    stroke: "#818C96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.83 10.884 1.473-1.473.59-.59a3.333 3.333 0 0 0 0-4.714v0a3.333 3.333 0 0 0-4.714 0l-.59.59L9.116 6.17m1.768 7.66-1.473 1.473-.59.59a3.333 3.333 0 0 1-4.713 0v0a3.333 3.333 0 0 1 0-4.715l.589-.589L6.17 9.116",
    stroke: "#747F88",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.946 7.054-5.892 5.892",
    stroke: "#818C96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.946 7.054-5.892 5.892",
    stroke: "#747F88",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLink;